<template>
  <div class="relative w-full"
       :class="{open: isOpenMenu}"
       ref="dropdown">
    <div @click="toggleDropdown" class="c-dropdown__button">
      <slot name="button"/>
    </div>
    <transition name="slide-fade">
      <div v-show="isOpenMenu"
           class="absolute w-full z-30"
           :class="{show: isOpenMenu}">
        <slot name="list"/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    disabledBody: {
      // Запретить скролл в body
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpenMenu: this.isOpen,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  watch: {
    isOpenMenu() {
      this.toggleLockBody()
    }
  },

  methods: {
    toggleDropdown() {
      this.isOpenMenu = !this.isOpenMenu;
    },
    close() {
      // для закрытия из родительского компонента можно использовать ref
      // <dropdown ref="dropdownMenuCategories">
      // в нужном обработчике вызвать this.$refs.dropdownMenuCategories.close();
      this.isOpenMenu = false;
    },
    open() {
      this.isOpenMenu = true;
    },
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpenMenu = false;
      }
    },
    toggleLockBody() {
      if(!this.disabledBody) { return }

      if (this.isOpenMenu) {
        // блокируем скрол в body
        document.body.classList.add('dropdown-menu-open');
      } else {
        document.body.classList.remove('dropdown-menu-open');
      }
    }

  }
};
</script>

<style>
body.dropdown-menu-open {
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>